import Header from 'components/text/header';
import UseApi from 'hooks/useApi';
import { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';

const AreaChart = () => {
  const { getApi } = UseApi();
  const [revenue, setRevenue] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res: any = await getApi(`admin-actions/revenue-month`);
      setRevenue(res?.data?.data);
    };
    fetchData();
  }, []);

  const options = {
    chart: {
      id: 'revenue-area',
    },
    xaxis: {
      categories: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'June',
        'July',
        'Aug',
        'Sep',
        'Nov',
        'Dec',
      ],
    },
  };
  const series = [
    {
      name: 'revenue ',
      data: revenue,
    },
  ];

  return (
    <div>
      <Header extraClasses="my-4">Total Revenue (PKR)</Header>
      {revenue && (
        <Chart
          options={options}
          series={series}
          type="area"
          className="mx-auto  w-full md:w-5/6  lg:w-3/4"
        />
      )}
    </div>
  );
};

export default AreaChart;
